const amostraLegenda = [
    "Amostragem Insuficiente",
    "Amostra Moderada",
    "Amostra Estável",
    "Amostra Altamente Estável"
];
export default amostraLegenda;